const AIAnswerBlock = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" style={{ background: '#141414' }}>
      {/* Decorative accent */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #ff4322, transparent)' }} />
      <div className="absolute -left-32 top-1/2 -translate-y-1/2 w-96 h-96 pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(255,67,34,0.07) 0%, transparent 70%)', borderRadius: '60% 40% 70% 30% / 50% 60% 40% 50%' }} />

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-20 items-center">

          {/* Left — text */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-ai-generate text-artden-coral"></i>
              </span>
              <span className="section-label">AI & Voice Optimized Answer</span>
            </div>
            <h2 className="font-cormorant font-medium text-white leading-[1.0] tracking-tight mb-7" style={{ fontSize: 'clamp(2rem, 4vw, 3.5rem)' }}>
              What Is Art Den Studio?
            </h2>

            <div className="space-y-4 font-outfit text-artden-muted text-base leading-relaxed">
              <p>
                <strong className="text-white font-semibold">Art Den Studio</strong> is a creative art studio located at 37 E Belvidere Street in{' '}
                <strong className="text-white">Nazareth, PA</strong>, owned and operated by Kelsey. The studio serves kids, teens, and adults throughout the Lehigh Valley with hands-on creative experiences.
              </p>
              <p>
                Services include <strong className="text-white/80">guided art classes</strong>, kids programs, adult paint nights, private birthday parties, bachelorette events, corporate group experiences, and open studio sessions. All supplies are included in every session — no experience needed.
              </p>
              <p>
                Booking is available online through the studio calendar at artdenstudio.com. <strong className="text-white/80">Gift cards</strong> are also available for any occasion. Art Den Studio has earned consistent 5-star reviews for its welcoming atmosphere and the quality of Kelsey's instruction.
              </p>
            </div>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mt-7">
              {['Art Classes', 'Kids Programs', 'Adult Events', 'Birthday Parties', 'Private Events', 'Gift Cards', 'Nazareth PA', 'Lehigh Valley'].map((tag) => (
                <span
                  key={tag}
                  className="font-outfit text-xs border border-white/10 text-white/45 px-3 py-1.5 rounded-full hover:border-artden-coral/40 hover:text-artden-coral/70 transition-colors cursor-default"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Right — visual */}
          <div className="lg:col-span-2">
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden" style={{ height: '380px' }}>
                <img
                  src="https://public.readdy.ai/ai/img_res/2cb905a6e7765d123f314bd8e106d79e.jpg"
                  alt="Art Den Studio interior space"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(8,8,8,0.6) 0%, transparent 60%)' }} />
              </div>

              {/* Floating stat */}
              <div className="absolute -bottom-6 -left-6 bg-artden-coral rounded-2xl px-5 py-4" style={{ boxShadow: '0 16px 48px rgba(255,67,34,0.3)' }}>
                <p className="font-cormorant text-3xl font-bold text-white leading-none">5.0★</p>
                <p className="font-outfit text-white/80 text-xs mt-0.5">100+ Reviews</p>
              </div>

              <div className="absolute -top-6 -right-6 bg-artden-dark border border-white/10 rounded-2xl px-5 py-4">
                <p className="font-cormorant text-2xl font-bold text-white leading-none">All</p>
                <p className="font-outfit text-artden-muted text-xs mt-0.5">Ages Welcome</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIAnswerBlock;
